<ng-select  class="year-picker" [ngClass]="{'selected': submit}"  #ngSelectControl [items]="calenderYear" [clearable]="false" [closeOnSelect]="false" 
    [placeholder] = 'getPlaceholder()'
    [searchable]="false" 
    [clearable]="false"  
   >
    <ng-template ng-header-tmp>  
        <div class="year-header">
            <div class="month-header__label"> {{yearTo}}-{{yearFrom}} </div>
            <div  class="month-header__arrow">
                <snl-icon  icon="fa-solid fa-chevron-left" class="month-header__stepper month-header__stepper--previous df-c " (click)="prevNextYear('prev')"></snl-icon>
                <snl-icon icon="fa-solid fa-chevron-right" class="month-header__stepper month-header__stepper--next df-c" (click)="prevNextYear('next')"></snl-icon>
            </div>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">  
        <div [ngClass]="{'year__hover--selected' :  item > years[0] && item < years[1],'year__year--start' : item == years[0],'year__year--end' : item == years[1]  }">
            <span [ngClass]="{'active': item === years[0] || item === years[1],'year--disabled': item > max || item < min }"  (click)="selectYear(item)">{{item}}</span>
        </div>
        
    </ng-template>
    <ng-template ng-footer-tmp> 
        <snl-button [type]="'primary'" [size]="'large'"  [disabled]="years.length < 2"  (click)="apply()">Apply</snl-button>
        <snl-button [type]="'secondary'" [size]="'large'" [disabled]="false" (click)="reset()">Cancel</snl-button>
    </ng-template> 
</ng-select>

